import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import styled, { css } from 'styled-components';
import { ORDERED_DIMENSIONS } from '../../../../../../../common/model/types';
import { tabletOrNarrower } from '../../../../../generic/layout/breakpoint-utils';
import { Bottom } from './bottom';
import { ColumnTitlesRow } from './column-titles-row';
import { useImpactChartContext, useImpactChartWidths } from './context';
import { DimensionBlock } from './dimension-block';
import { ImpactExplanationModalMaybe } from './impact-explanation-modal-maybe';
import { MainTitleRow } from './main-title-row';
import { TopInputsRow } from './top-inputs-row';
import { ValueChainsLegend } from './value-chain-legend';

export function NetImpactChartMain() {
  const { desktopMode, showValueChains, width, className, simplify } = useImpactChartContext();
  const { titleTextPadding } = useImpactChartWidths();

  return (
    <Root data-testid={E2eTestElementId.NET_IMPACT_CHART} style={{ width }} className={className}>
      <MainTitleRow />
      <TopInputsRow />
      <ScoreContentWrap>
        <ColumnTitlesRow />
        {ORDERED_DIMENSIONS.map(dimension => {
          return (
            <div key={dimension} style={{ marginTop: -2 }}>
              <DimensionBlock dimension={dimension} />
            </div>
          );
        })}
        {simplify ? undefined : <Bottom />}
        {desktopMode && showValueChains && (
          <ValueChainWrap style={{ paddingLeft: titleTextPadding }}>
            <ValueChainsLegend />
          </ValueChainWrap>
        )}
      </ScoreContentWrap>
      <ImpactExplanationModalMaybe />
    </Root>
  );
}

const Root = styled.div`
  margin-left: auto;
  margin-right: auto;
`;

const ValueChainWrap = styled.div`
  padding-top: 1.3em;
`;

const ScoreContentWrap = styled.div`
  ${tabletOrNarrower(css`
    padding-left: 0;
    padding-right: 0;
  `)};
`;
